import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError)

function getStatus() {
	return client.get('tunnel/api/stockist/dashboard/total-transaction');
}

export default {
	getStatus
}